import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import axios from 'axios'
import { Alert, Button, Form, Spinner } from 'react-bootstrap'
import { isIterableArray } from '../../../block-slider/utils'
import eyeSrc from '../../../../img/eye.svg'
import eyeCloseSrc from '../../../../img/eye-close.svg'
import fontColorContrast from 'font-color-contrast'

const FormAuth = ({ inputsData, tabs, handleRegister, handleClose }) => {
    const {
        register,
        handleSubmit,
        reset,
        control,
        setValue,
        formState: { errors, isValid },
    } = useForm({
        mode: 'onChange',
    })


    const {
        button_color,
        text_1, // текст под кнопкой авторизации
        text_2, // кнопка авторизация  
        text_3, // заголовок для Авторизации

        // text_4, // заголовок для Востановление пароля
        // text_5, // кнопка для Востановления отправить емаил   

        // text_6, // заголовок для ввода кода подтверждения 
        // text_7, // заголовок для успешном вводе кода подтверждения 
        // text_8, // текст прислать заново код
        // text_9, // текст кнопки Отправить код
        // text_10, // заголовок для блока регистрации
        // text_11, // кнопка зарегестрироваться
    } = inputsData?.setting

    const [passwordInputData, setPasswordInputData] = useState(null)
    const [emailInputData, setEmailInputData] = useState(null)

    const [isPassword, setIsPassword] = useState(true)

    const [isLoading, setIsLoading] = useState(false)

    const [isAlertError, setIsAlertError] = useState(false);
    const [textOnError, setTextOnError] = useState('');


    useEffect(() => {
        if (isIterableArray(inputsData?.items)) {
            const passwordI = inputsData.items.find(i => i.forEmail === 'password')
            const emailI = inputsData.items.find(i => i.forEmail === 'email')
            if (passwordI) setPasswordInputData(passwordI)
            if (emailI) setEmailInputData(emailI)
        }
    }, [inputsData])

    const onSubmit = (formData) => {

        // const info = await fetchClientInfo()
        formData.password = formData.password.trim()
        formData.email = formData.email.trim()
        setIsLoading(true)
        axios.post(`${process.env.REACT_APP_API_BASE}/cabinet/login`, formData)
            .then((response) => {
                if (response?.data?.token?.token) {
                    localStorage.setItem('galaxy-token', response.data.token.token)
                    handleClose()
                    if (window.location.pathname !== '/cart') {
                        window.location.href = '/profile'
                    } else {
                        document.location.reload();
                    }
                }
                else {
                    setIsAlertError(true)
                    const errText = response?.data?.errorMes || 'Что-то пошло не так, попробуйте повторить позже'
                    setTextOnError(errText)
                }
            }).catch(err => {
                setIsAlertError(true)
                setTextOnError('Ошибка сервиса')
                console.error(err)
            })
            .finally(() => {
                setIsLoading(false)
            })

    }

    return (
        <div className="block-login">

            {
                isAlertError &&
                <Alert variant={'danger'} onClose={() => {
                    setIsAlertError(false)
                    setTextOnError('')
                }} dismissible>
                    <Alert.Heading style={{ fontSize: '1.15rem' }}>Ошибка</Alert.Heading>
                    <p className='mb-0'>{textOnError}</p>
                </Alert>
            }
            <form onSubmit={handleSubmit(onSubmit)}>
                {text_3 && <div className='my-2 text-center' dangerouslySetInnerHTML={{ __html: text_3 }} />}
                {
                    emailInputData &&
                    <div style={{ marginBottom: 16 }}>
                        <Form.Control
                            placeholder={emailInputData.text}
                            type="email"
                            {...register(emailInputData.forEmail, {
                                required: !!emailInputData.required,
                                pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
                            })}
                        />
                    </div>
                }
                {
                    passwordInputData &&
                    <div style={{ position: 'relative', marginBottom: 16 }}>
                        <Form.Control
                            placeholder={passwordInputData.text}
                            type={isPassword ? "password" : 'text'}
                            {...register(passwordInputData.forEmail, {
                                required: !!passwordInputData.required,
                                // minLength: 8,
                                // pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/
                            })}
                        />
                        <div
                            style={{
                                cursor: 'pointer',
                                padding: '6px 12px',
                                position: 'absolute',
                                top: 0,
                                right: 0,
                            }}
                            onClick={() => setIsPassword(prev => !prev)}
                        >
                            {
                                isPassword ?
                                    <img src={eyeSrc} style={{ width: 30, height: 22 }} alt="Eye" />
                                    :
                                    <img src={eyeCloseSrc} style={{ width: 30, height: 22 }} alt="Eye" />
                            }
                        </div>
                    </div>
                }

                <div style={{ display: 'flex', marginBottom: 16 }}>
                    <Button
                        className='d-inline-block w-auto mt-0'
                        variant="link"
                        onClick={() => {
                            tabs(2)
                        }}
                    >
                        Забыли пароль?
                    </Button>
                </div>
                <button
                    disabled={!isValid}
                    className='btn btn-submit mt-0'
                    type='submit'
                    style={{
                        backgroundColor: button_color,
                        color: fontColorContrast(button_color)
                    }}
                >
                    {
                        isLoading ?
                            <Spinner animation='border' />
                            :
                            <div dangerouslySetInnerHTML={{ __html: text_2 || 'Отправить' }}></div>
                    }
                </button>

                {
                    text_1 &&
                    <div className='text_under mt-3' dangerouslySetInnerHTML={{ __html: text_1 }} />
                }
            </form>
            <hr />
            <div className="d-flex justify-content-center mt-3">
                <Button
                    variant="link"
                    onClick={handleRegister}
                    className='primary'
                    style={{
                        fontWeight: 500,
                        fontSize: '1.35em'
                    }}
                >
                    Зарегестрироваться
                </Button>
            </div>
        </div>

    )
}
export default FormAuth